export const _StoreApiKeys = [
  {
    name: 'Broker Prod',
    value: {
      apikey: 'c7546d31-870c-4a1b-801f-b0423d2004c3'
    }
  },
  {
    name: 'Broker Dev',
    value: {
      apikey: '839cba0b-c7f7-4c10-90e2-53f5965e63ff'
    }
  }
];

export const ApiKeySelector = 'API_KEY';
